import {
    FETCH_ACTION_BEGIN,
    FETCH_ACTION_SUCCESS,
    FETCH_ACTION_FAIL
  } from '../middleware/types'
  
  const initialState = {
    ACTION_loading: false,
    error: {},
    response : {}
  }

  export default (state = initialState, action) => {
    switch (action.type) {
      case FETCH_ACTION_BEGIN:
        return {
          ...state,
          ACTION_loading: true
        }
      case FETCH_ACTION_SUCCESS:
          return {
              ...state,
              ACTION_loading: false,
              response: {
                ...action.payload
              }
          }
      case FETCH_ACTION_FAIL:
        return {
          ...state,
          ACTION_loading: false,
          error: action.payload
        }
      default:
        return state
    }
  }